import { showNotification } from '@lsq/nextgen/notification';
import { Type } from '@lsq/nextgen/v2/notification/notification.types';

/**
 * Plain-module toast helper — callable from non-React code
 * (axios interceptors, plain utilities, middleware). React code should
 * prefer the `useToast` hook which delegates here.
 */
const typeMap = {
  error: Type.ERROR,
  success: Type.SUCCESS,
  warning: Type.WARNING,
  info: Type.INFO
};

export const showToast = (type, message) =>
  showNotification({
    type: typeMap[type] ?? Type.INFO,
    message,
    parentElement: document?.body,
    // Scope our alignment fix (see .casa-toast in index.css) without affecting other consumers of
    // the nextgen notification.
    customStyleClass: 'casa-toast'
  });
